<template>
  <v-select
    v-model="valueSelected"
    :error-messages="error"
    :label="label"
    :items="optionsSexos"
    filled
    @change="_doEmits"
  />
</template>
<script>
export default {
  name: "SelectSexo",
  props: {
    error: String,
    label: String,
    value: String,
  },
  data() {
    return {
      valueSelected: null,
      optionsSexos: [
        { text: "Femenino", value: "femenino" },
        { text: "Masculino", value: "masculino" },
        { text: "Prefiero no especificar", value: "prefiero no especificar" },
      ],
    };
  },
  methods: {
    _doEmits() {
      this.$emit("input", this.valueSelected);
      this.$emit("change", this.valueSelected);
    },
    _handleValue() {
      if (this.value != this.valueSelected) {
        this.valueSelected = this.value;
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      handler: "_handleValue",
    },
  },
  created() {
    this._handleValue();
  },
};
</script>